





import { Component, Prop, Vue} from 'vue-property-decorator';
import VueSimpleContextMenu from 'vue-simple-context-menu';

@Component
export default class LeftClickOptionMenu extends Vue {
    @Prop({
        type: String,
        default: ''
    })
    url: any;
    @Prop({
        type: String,
        default: ''
    })
    urlArgument: any;
    
    leftClickMenuOptions: any = [
        {
            name: 'Open in a new Tab',
            slug: 'open-new-tab'
        },
        {
            name: 'Open in a new Window',
            slug: 'open-new-window'
        },
        {
            type: 'divider',
        },
        {
            name: 'Copy url address',
            slug: 'copy-to-clipboard'
        }
    ];
    
    handleClick (event, item) {
        (this.$refs.vueContextMenuGroup as VueSimpleContextMenu).showMenu(event, item)
    }

    optionClicked (event) {
        let completeUrl = this.url + event.item[this.urlArgument];
        if(event.option.slug === "open-new-tab"){
            window.open(completeUrl, "_blank")
        } else if(event.option.slug === "open-new-window") {
            window.open(completeUrl, "","fullscreen");
        } else {
            navigator.clipboard.writeText(location.protocol + "//" + window.location.host + completeUrl);
        }
    }
}
